export default "__VITE_ASSET__CkUEi0SU__"